import React, { useEffect } from "react";
import Header from "../../../layout/Header";
import Footer from "../../../layout/Footer";
import ProductSection from "./ProductSection";
import HeroSection from "../../../layout/HeroSection";
import Loader from "../../../components/other/Loader";
import { useDispatch, useSelector } from "react-redux";
import { pageRoutes } from "../../../routes/pageRoutes";
import { fetchProducts } from "../../../redux/action/orderAction";

const GoodKidsToStart = () => {
  const dispatch = useDispatch();
  const { isLoading } = useSelector((state) => state?.orderReducer);

  useEffect(() => {
    dispatch(fetchProducts());
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  return (
    <div>
      <Header />
      <HeroSection
        label={<h1 className="mb-1">{"Good kits to start with"}</h1>}
        breadcrumbItems={[
          { name: "Home", path: `${pageRoutes?.home}/` },
          { name: "Good kits to start with", path: `${pageRoutes?.home}/` },
        ]}
      />

      <ProductSection />
      <Footer />
    </div>
  );
};

export default GoodKidsToStart;
